export default function DatenschutzPage() {
  return (
    <div className="bg-white" style={{ fontFamily: 'Inter, -apple-system, sans-serif' }}>
      {/* Hero */}
      <section className="py-24 md:py-32 bg-gradient-to-b from-[#FAF9F7] to-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Rechtliches
            </span>
            <h1 className="text-4xl md:text-[52px] font-bold text-gray-900 leading-tight tracking-tight">
              Datenschutz
            </h1>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-[800px] mx-auto px-4 md:px-8">
          <div className="prose prose-gray max-w-none">
            
            <div className="bg-[#FAF9F7] rounded-2xl p-8 mb-12">
              <h2 className="text-xl font-bold text-gray-900 mb-4 mt-0">1. Datenschutz auf einen Blick</h2>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Allgemeine Hinweise</h3>
              <p className="text-gray-600 leading-relaxed mb-0">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten 
                passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie 
                persönlich identifiziert werden können.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-xl font-bold text-gray-900 mb-4">2. Verantwortliche Stelle</h2>
              <p className="text-gray-600 leading-relaxed">
                <strong>asK-mi</strong><br />
                Kompetenzzentrum für menschliche Intelligenz<br /><br />
                c/o SteamWork<br />
                Roonstr. 23 a<br />
                76137 Karlsruhe<br /><br />
                E-Mail: <a href="mailto:we@ask-mi.com" className="text-[#A8923F] hover:underline">we@ask-mi.com</a>
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-xl font-bold text-gray-900 mb-4">3. Datenerfassung auf dieser Website</h2>
              
              <h3 className="text-lg font-semibold text-gray-900 mb-2 mt-6">Server-Log-Dateien</h3>
              <p className="text-gray-600 leading-relaxed">
                Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, 
                die Ihr Browser automatisch an uns übermittelt. Dies sind:
              </p>
              <ul className="text-gray-600 mt-4 space-y-2">
                <li>• Browsertyp und Browserversion</li>
                <li>• verwendetes Betriebssystem</li>
                <li>• Referrer URL</li>
                <li>• Hostname des zugreifenden Rechners</li>
                <li>• Uhrzeit der Serveranfrage</li>
                <li>• IP-Adresse</li>
              </ul>
              <p className="text-gray-600 leading-relaxed mt-4">
                Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser 
                Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
              </p>

              <h3 className="text-lg font-semibold text-gray-900 mb-2 mt-8">Kontaktaufnahme</h3>
              <p className="text-gray-600 leading-relaxed">
                Wenn Sie uns per E-Mail kontaktieren, werden Ihre Angaben einschließlich der von Ihnen dort angegebenen 
                Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. 
                Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-xl font-bold text-gray-900 mb-4">4. Ihre Rechte</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Sie haben jederzeit das Recht:
              </p>
              <ul className="text-gray-600 space-y-2">
                <li>• <strong>Auskunft</strong> über Ihre bei uns gespeicherten personenbezogenen Daten zu erhalten</li>
                <li>• <strong>Berichtigung</strong> unrichtiger personenbezogener Daten zu verlangen</li>
                <li>• <strong>Löschung</strong> Ihrer bei uns gespeicherten Daten zu verlangen</li>
                <li>• <strong>Einschränkung</strong> der Datenverarbeitung zu verlangen</li>
                <li>• <strong>Widerspruch</strong> gegen die Verarbeitung Ihrer Daten einzulegen</li>
                <li>• <strong>Datenübertragbarkeit</strong> zu verlangen</li>
              </ul>
            </div>

            <div className="mb-12">
              <h2 className="text-xl font-bold text-gray-900 mb-4">5. Externe Links</h2>
              <p className="text-gray-600 leading-relaxed">
                Diese Website enthält Links zu externen Websites. Wenn Sie diese Links nutzen, verlassen Sie unsere 
                Website. Wir haben keinen Einfluss auf den Inhalt und die Datenschutzpraktiken dieser externen Websites 
                und übernehmen dafür keine Verantwortung.
              </p>
            </div>

            <div className="bg-[#FAF9F7] rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4 mt-0">6. Änderungen</h2>
              <p className="text-gray-600 leading-relaxed mb-0">
                Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen 
                Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen. 
                Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
              </p>
            </div>

            <p className="text-sm text-gray-500 mt-8">
              Stand: {new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
